// 🔧 promotion_defaults.js
// ✅ Purpose: Central default configuration for the LGV Promotion Engine
// ✅ Features:
// - Defines default engine behavior
// - Keeps UI and services free of hardcoded values
// - Serves as the baseline for future Promotion Settings
// - Supports future manager-level overrides
// - Fully block-commented for clarity and future devs

import {
  PROMOTION_SCOPES,
} from "./promotion_settings_map";

/**
 * ============================================================================
 * ENGINE DEFAULTS
 * ============================================================================
 *
 * These values represent the Promotion Engine's built-in behavior.
 *
 * Future:
 * Promotion Settings (Firestore) may override these values.
 */

export const PROMOTION_DEFAULTS = {
  /**
   * Engine
   */
  enabled: true,

  /**
   * AI
   */
  aiEnabled: true,

  /**
   * Images
   */
  imageGenerationEnabled: true,

  /**
   * Scheduling
   */
  schedulerEnabled: true,

  autoPublishEnabled: false,

  /**
   * Default scope.
   *
   * MVP 1:
   * Internal LGV marketing only.
   *
   * MVP 2:
   * Event scope becomes available.
   */
  defaultScope: PROMOTION_SCOPES.INTERNAL_LGV,

  /**
   * AI limits
   */
  maxIdeasGeneratedPerRun: 10,

  maxPostsGeneratedPerRun: 10,

  /**
   * Queue
   */
  maxScheduledPostsPerRun: 25,

  /**
   * Dashboard
   */
  dashboardPageSize: 25,

  /**
   * Future analytics
   */
  retainHistoryDays: 3650,

  /**
   * Future AI recommendations
   */
  enableRotationRecommendations: true,

  /**
   * MVP 2
   */
  enableCampaigns: false,

  enableManagerAccounts: false,

  enableProviderIntegrations: false,
};

/**
 * ============================================================================
 * DEFAULT FILTERS
 * ============================================================================
 *
 * Used when pages first load.
 */

export const PROMOTION_DEFAULT_FILTERS = {
  platform: "all",

  platformFeature: "all",

  postType: "all",

  category: "all",

  campaign: "all",

  status: "all",

  dateRange: "all",
};

/**
 * ============================================================================
 * DEFAULT SORTING
 * ============================================================================
 */

export const PROMOTION_DEFAULT_SORT = {
  field: "updatedAt",

  direction: "desc",
};